






import Axios from 'axios';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { UserLoginParam } from 'src_server/param/UserLoginParam';
import { Response } from '../../../src_server/response/Response';
import { UserAuthDTO } from '../../../src_server/entity/dto/UserAuthDTO';

import { URIs } from '../../../src_server/common/URIs';
import { Session } from '../../utils/Session';
import { WebUtils } from '../../utils/WebUtils';
import { ErrorHandler } from '../../utils/ErrorHandler';
import { UserType } from '../../../src_server/biz/UserType';
import { MessageDialog } from '../../utils/MessageDialog';
import { buildingData } from '../../../src_server/entity/master/buildingData';
@Component({ components: {} })
export default class LoginButton extends Vue {
  @Prop({ default: '' })
  mail!: string;
  @Prop({ default: '' })
  password!: string;
  @Prop({ default: 'adm', required: true })
  type!: UserType;

  @Prop()
  title!: string;

  get titleMessage() {
    return this.title;
  }

  // @Prop({ default: '' })
  building!: string;

  private css_class = ['d-block', 'py-2', 'px-3', 'w-14rem', 'mt-1'];

  created() {
    const queryBuilding = this.$route.query['building'];
    if (!queryBuilding || queryBuilding instanceof Array) {
      MessageDialog.alert('クエリパラメータにbuildingがセットされていません。');
      MessageDialog.systemError('校舎', 'ログインボタン表示時', queryBuilding);
      return;
    }
    const existBuildingMaster = !buildingData.find((item) => {
      item.building_id === queryBuilding;
    });
    if (!existBuildingMaster) {
      MessageDialog.systemError('校舎', 'マスタチェック時', queryBuilding);
      return;
    }

    this.building = queryBuilding;
  }

  login() {
    sessionStorage.clear();
    const param: UserLoginParam = {
      mail: this.mail,
      password: this.password,
      type: this.type,
      building: this.building,
    };

    Axios.post<Response<UserAuthDTO>>(URIs.USERS_LOGIN.path, param)
      .then((response) => {
        if (response.data.hasError) {
          ErrorHandler.atResponseError(response.data);
          return;
        }

        Session.set<UserAuthDTO>('USER', response.data.data);
        try {
          let redirectPath = WebUtils.getQueryItem('redirect', location);
          console.log(redirectPath);
          if (!redirectPath) {
            switch (this.type) {
              case 'tea':
                redirectPath = `/teacher-dashboard-page?building=${this.building}`;
                break;
              case 'stu':
                redirectPath = `/student-dashboard-page?building=${this.building}`;
                break;
              case 'adm':
                redirectPath = `/admin-menu-page?building=${this.building}`;
                break;
            }
          }
          this.$router.push(redirectPath);
        } catch (e) {
          alert(e);
        }
      })
      .catch((error) => {
        alert(error.description);
      });
  }
}
